import React from 'react';
import { withRouter } from 'react-router-dom'
import "./Profile.css";
import Navbar from "../Components/Navbar";
import Footer from "../Components/Footer";

class Pricing extends React.Component {

    render() {
        return (
            <div style={{ backgroundColor: '#60a3bc',height:'90vh'}} >

                <Navbar />
                <div className="">
                    <div className="row text-center" style={{padding:'40px'}}>
                        <div className="col-md-12">
                            <div className="row">
                                <div className="col-md-4">
                                    <div className="list-group text-center pricing">
                                        <div className="title">
                                            <h4 style={{marginBottom:'20px'}}>Student (Omani/Non-Omani)</h4>
                                        </div>
                                        <div className="content">
                                            <ul className="list-unstyled">
                                            <li><span style={{ fontSize: '24px', fontWeight: 600, color: '#aa1e40' }}><p />OMR 20</span></li>
                                                <li>Full Year</li>
                                                <li><a className="btn btn-success" href="/membership">Apply Now</a></li>
                                                <li style={{borderBottom: '1px solid #e0e0e0'}}></li>
                                                <li><span style={{ fontSize: '24px', fontWeight: 600, color: '#aa1e40' }}><p />OMR 12</span></li>
                                                <li>Half Year</li>
                                                <li><a className="btn btn-success" href="/membership">Apply Now</a></li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-4">
                                    <div className="list-group text-center pricing">
                                        <div className="title">
                                            <h3>Omani/GCC</h3>
                                        </div>
                                        <div className="content">
                                            <ul className="list-unstyled">
                                                <li><span style={{ fontSize: '24px', fontWeight: 600, color: '#aa1e40' }}><p />OMR 60</span></li>
                                                <li>Full Year</li>
                                                <li><a className="btn btn-success" href="/membership">Apply Now</a></li>
                                                <li style={{borderBottom: '1px solid #e0e0e0'}}></li>
                                                <li><span style={{ fontSize: '24px', fontWeight: 600, color: '#aa1e40' }}><p />OMR 35</span></li>
                                                <li>Half Year</li>
                                                <li><a className="btn btn-success" href="/membership">Apply Now</a></li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-4">
                                    <div className="list-group text-center pricing">
                                        <div className="title">
                                            <h3>Non-Omani</h3>
                                        </div>
                                        <div className="content">
                                            <ul className="list-unstyled">
                                            <li><span style={{ fontSize: '24px', fontWeight: 600, color: '#aa1e40' }}><p />OMR 80</span></li>
                                                <li>Full Year</li>
                                                <li><a className="btn btn-success" href="/membership">Apply Now</a></li>
                                                <li style={{borderBottom: '1px solid #e0e0e0'}}></li>
                                                <li><span style={{ fontSize: '24px', fontWeight: 600, color: '#aa1e40' }}><p />OMR 45</span></li>
                                                <li>Half Year</li>
                                                <li><a className="btn btn-success" href="/membership">Apply Now</a></li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
                <Footer />
            </div>
        )
    }
}
export default withRouter(Pricing);
